import AppProviders from "@app/providers/AppProviders";
import { router } from "@app/routes";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

if (["int", "preprod", "prod"].includes(import.meta.env.VITE_ENVIRONMENT)) {
  Sentry.init({
    dsn: "https://fca87fb9d7119f0c2307e7f207ebea86@o4504841630384128.ingest.us.sentry.io/4511149677019136",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: import.meta.env.VITE_ENVIRONMENT,
    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === "prod" ? 0.25 : 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/pid-kks-extractor/],
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
